import React from 'react';

import { DiceReceiverError } from '../errors';

export interface ErrorHandlerProps {
    error: Error;
}

export const ErrorHandler: React.FC<ErrorHandlerProps> = ({ error }) => {
    let title = 'Oops...';
    let description = 'Something went wrong. Please try again later.';
    let errorCode = 'N/A';

    if (error instanceof DiceReceiverError) {
        title = error.title;
        description = error.message;
        errorCode = error.code;
    }

    return <Error description={description} title={title} errorCode={errorCode} />;
};

interface ErrorProps {
    description: string;
    errorCode: string;
    title: string;
}

const Error: React.FC<ErrorProps> = ({ description, title, errorCode }) => {
    return (
        <div className="error">
            <h1 className="error__title">{title}</h1>
            <p className="error__description">{description}</p>
            <div className="error__details">
                Error code: <span className="error__code">{errorCode}</span>
            </div>
            <div className="error__logo" />
        </div>
    );
};
